module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0",
      "border": "0"
    },
    attrs: {
      "href": "https://github.com/cameronhimself/vue-drag-drop",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://camo.githubusercontent.com/e7bbb0521b397edbd5fe43e7f760759336b5e05f/68747470733a2f2f73332e616d617a6f6e6177732e636f6d2f6769746875622f726962626f6e732f666f726b6d655f72696768745f677265656e5f3030373230302e706e67",
      "alt": "Fork me on GitHub",
      "data-canonical-src": "https://s3.amazonaws.com/github/ribbons/forkme_right_green_007200.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65539a05","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/GithubRibbon.vue
// module id = 48
// module chunks = 0